

export default function Navbar() {
    return (
        <nav className="navbar navbar-expand-md navbar-dark bg-dark shadow">
       <img src="%PUBLIC_URL%/../am.png" alt="logo" ></img><a className="navbar-brand" href="/">Astra<b>Medika</b></a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item active">
              <a className="nav-link" href="/">Home</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="about">O nama</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="reference">Reference</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="contact">Kontakt</a>
            </li>
            {/* <li className="nav-item">
              <a className="nav-link disabled" href="#">Disabled</a>
            </li> */}
          </ul>
          {/* <form className="form-inline my-2 my-lg-0">
            <input className="form-control mr-sm-2" type="search" placeholder="Search" aria-label="Search" />
            <button className="btn btn-outline-success my-2 my-sm-0" type="submit">Search</button>
          </form> */}
        </div>
        </nav>
  
    );
  }
  

  

